import { render, staticRenderFns } from "./MetricWire.vue?vue&type=template&id=d3d28c66&scoped=true"
import script from "./MetricWire.vue?vue&type=script&lang=js"
export * from "./MetricWire.vue?vue&type=script&lang=js"
import style0 from "./MetricWire.vue?vue&type=style&index=0&id=d3d28c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d28c66",
  null
  
)

export default component.exports